<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Sources
        <small>List of Sources</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Sources</li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter Sources</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: hidden;">
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="name">
                  Name
                </label>

                <input type="text"
                  class="form-control"
                  id="name"
                  placeholder="Search by name here"
                  v-model="params.name"
                  @keyup="onInput">
              </div>
            </div>

            <div class="col-12 col-md-6">
              <div class="form-group">
                <label for="contact">
                  Contact
                </label>

                <input type="text"
                  class="form-control"
                  id="contact"
                  placeholder="Search by contact here"
                  v-model="params.contact"
                  @keyup="onInput">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box">
        <div class="box-header">
          <a class="btn btn-success pull-right"
            @click.prevent="add">
            Add New Source
          </a>
        </div>

        <div class="box-body">
          <table id="table" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Source Name</th>
                <th class="text-center">Source Code</th>
                <th>Contact Person</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Action(s)</th>
              </tr>
            </thead>

            <tbody>
              <tr v-if="!vendors" key="empty">
                <td colspan="6">
                  <strong>Result not found</strong>
                </td>
              </tr>
              <tr v-for="vendor in vendors" v-else>
                <td>{{ vendor.name }}</td>
                <td class="text-center">{{ vendor.code }}</td>
                <td>{{ vendor.contact_person }}</td>
                <td>{{ vendor.phone }}</td>
                <td>{{ vendor.email }}</td>
                <td style="min-width: 10rem;">
                  <a class="btn btn-primary btn-xs" @click.prevent="edit(vendor.id)">Edit</a>
                  <a class="btn btn-danger btn-xs" @click.prevent="remove(vendor)">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="box-footer">
          <Pagination
            :pagination="pagination"
            @goto-page="changePage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'VendorIndex',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      vendors: [],
      pagination: {},

      params: {
        name: null,
        contact: null,
      },
    };
  },

  methods: {
    fetch(page) {
      const pageQuery = this.$route.query.page;
      this.params.page = page || pageQuery;


      this.axios.get('/vendors', {
        params: this.params,
          responseType: this.type,
        })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            this.vendors = null;
            this.pagination = {};
            return;
          }

          this.vendors = data;
          this.pagination = meta.pagination;
        });

      if (page) {
        window.history.pushState(`Vendors page: ${page}`, null, `/sources?page=${page}`);
      }
    },

    onInput: debounce(function debouncedInput() {
      this.fetch();
    }, 500),

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({
        name: 'source-create',
      });
    },

    edit(id) {
      this.$router.push({
        name: 'source-edit',
        params: {
          id,
        },
      });
    },

    delete(vendor) {
      this.axios.delete(`/vendors/${vendor.id}`)
        .then(() => {
          this.fetch();

          this.$swal({
            title: 'Deleted',
            text: `${vendor.name} has been deleted.`,
            type: 'success',
            timer: 2000,
          });
        });
    },

    remove(vendor) {
      this.$swal({
        title: 'Deleting Source',
        text: `Are you sure you want to delete ${vendor.name}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.value) {
          this.delete(vendor);
        } else {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 2000,
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 2000,
          });
        }
      });
    },
  },

  created() {
    this.fetch();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/vendors/Index.vue